import { Component } from '@angular/core';
import { AuthService } from './services/auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  isAuthenticated$: Observable<boolean>;

  constructor(private _authService: AuthService) {
    this.isAuthenticated$ = this._authService.credential$.pipe(
      map(credential => !!credential)
    );
  }

}
